import React, { useEffect } from 'react';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface ModelUnavailableViewProps {
	onContinueBrowsingClicked: () => void;
}

//-----------------------------------------------------------------------------------------
// Constants:
//-----------------------------------------------------------------------------------------

const SUPERSPORT_CONFIGURATOR_URL = 'https://configure.morgan-motor.com/supersport/';	// the supersport configurator, which is published to its own URL.
const MORGAN_CONTACT_US_URL = 'https://morgan-motor.com/contact-us/';					// the contact page on the main morgan website.

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

/**
 * Stands in front of the home view when the configured model is not available in the visitor's
 * region, pointing them at the models that are. Dismissing it reveals the home view as normal,
 * where the region selector lets them correct their region if it was detected wrongly.
 */
export function ModelUnavailableView(props: ModelUnavailableViewProps) {

	// runs once, after initial render...
	useEffect(() => {

		// add the home page class to the body, as this view stands in for the home view.
		document.body.classList.add('home-page');

		// remove the home page class when navigating away from the page.
		return () => {
			document.body.classList.remove('home-page');
		};
	}, []);

	// handlers.

	const handleViewSupersportClicked = () => {

		// send the visitor to the supersport configurator, in the same tab.
		window.location.href = SUPERSPORT_CONFIGURATOR_URL;
	}

	const handleGetInTouchClicked = () => {

		// send the visitor to the contact page, in the same tab.
		window.location.href = MORGAN_CONTACT_US_URL;
	}

	// return the HTML.
	return (
		<div id="model-unavailable-view">
			<div id="model-unavailable-card">
				<div id="model-unavailable-image">
					<img src="assets/images/misc/supersport-400-us-availability.webp" width="1600" height="1066" alt="A Morgan Supersport on a mountain road" />
					<button type="button" id="mu-close-button" aria-label="Close" onClick={props.onContinueBrowsingClicked}>
						<img src="assets/images/icons/close.svg" width="27" height="27" alt="Close" />
					</button>
				</div>
				<div id="model-unavailable-content">
					<h2 id="ga4-supersport-400-availability">Supersport 400 availability</h2>
					<p>
						The Supersport 400 is not currently available in the United States. Discover the Supersport
						models available in your market, or speak with our team to find the right model for you.
					</p>
				</div>
				<div id="model-unavailable-footer">
					<button type="button" id="mu-view-supersport-button" onClick={handleViewSupersportClicked}>
						View Supersport
						<img src="assets/images/icons/long-arrow.svg" width="16" height="16" alt="" />
					</button>
					<button type="button" id="mu-continue-browsing-button" onClick={props.onContinueBrowsingClicked}>
						Continue Browsing
					</button>
					<button type="button" id="mu-get-in-touch-button" onClick={handleGetInTouchClicked}>
						Get in Touch
					</button>
				</div>
			</div>
		</div>
	);
}
